import { IVo, entity, field } from '@wizeoo/akm-compute-lib';
import { CssRender, TranslatedEmb } from '@wizeoo/akm-message-lib';
import { TranslatableLabelVO } from '../common/translation/translatable-label.vo';
import { Model } from '../../model/model';
import { WizMathUtils } from '@wizeoo/akm-core-lib';

/**
 * VO représentant un rendu css
 */
@entity('wizeoo.allkeyme.workingdata.message.CssRender', 'VISION')
export class CssRenderVO implements IVo {
  

  protected _model: Model = null;
  protected get model(): Model {
    return this._model as Model;
  }
  protected set model(value: Model) {
      this._model = value;
  }
  
  constructor(model: Model, pSource?: CssRender) {
        this._model = model;
        this._source = null;
        if (pSource) {
            this._source = pSource;
        } else {
            this._source = new CssRender();
            this._source.uid = WizMathUtils.createUUID(); // génération du UID si nouveau
        }
  }

  /** L'objet source provenant du back */
  protected _source: CssRender;

  public get source(): CssRender {
      return this._source;
  }
  public set source(value: CssRender) {
      this._source = value;
  }

  // code domaine (root), technique
  public get domain(): string {
      return this._source.domain;
  }
  public set domain(value: string) {
      this._source.domain = value;
  }

  public get businessUnitCode(): string {
      // code de la BU
      return this._source.businessUnitCode;
  }
  public set businessUnitCode(value: string) {
      this._source.businessUnitCode = value;
  }



  @field('maintenanceFlag') // patch pour s'assurer de la demande de mise à jour sur contenu des lines
  public get maintenanceFlag(): string {
    return this.source.maintenanceFlag;
  }
  public set maintenanceFlag(value: string) {
    this.source.maintenanceFlag = value;
  }

  /**
   * code unique du format dans la bu
   */
  @field('string')
  public set code(value: string) {
    this.source.code = value;
  }
  public get code(): string {
    return this.source.code;
  }

  @field('string')
  public set shortCode(value: string) {
    this.source.shortCode = value;
  }
  public get shortCode(): string {
    return this.source.shortCode;
  }

  /** type de donnée */
  @field('string')
  public set vision(value: string) {
    this.source.vision = value;
  }
  public get vision(): string {
    return this.source.vision;
  }

  /**
   * expression pour rendu
   */
  @field('string')
  public set css(value: string) {
    this.source.css = value;
  }
  public get css(): string {
    return this.source.css;
  }

  // Id technique
  public get id(): number {
    return this.source.id;
  }
  public set id(value: number) {
    this.source.id = value;
  }

  // UID technique
  public get uid(): string {
    return this.source.uid;
  }
  public set uid(value: string) {
    this.source.uid = value;
  }

  public get version(): number {
    // technique
    return this.source.version;
  }
  public set version(value: number) {
    this.source.version = value;
  }

  @field('TranslatedEmb')
  public set label(value: TranslatedEmb) {
    this.source.label = value;
  }
  public get label(): TranslatedEmb {
    return this.source.label;
  }

  @field('TranslatedEmb')
  public set description(value: TranslatedEmb) {
    this.source.description = value;
  }
  public get description(): TranslatedEmb {
    return this.source.description;
  }

  /* ################################################
              gestion de la traduction
  ################################################ */

  /**
   * Return translated label
   * @return string
   */
  get trsLabel(): string {
    return this.model.localeEngine.translate(this.label, this.shortCode);
  }

  /**
   * Return translated label
   * @return string
   */
  get trsDescription(): string {
    return this.model.localeEngine.translate(this.description);
  }

  /** Libellé traductible */
  private _labelVO: TranslatableLabelVO;
  public get labelVO(): TranslatableLabelVO {
    if (!this._labelVO) {
      this._labelVO = this.model.localeEngine.newTranslatableVO(this, 'label');
    }
    return this._labelVO;
  }

  /** description en mode VO */
  private _descriptionVO: TranslatableLabelVO;
  public get descriptionVO(): TranslatableLabelVO {
    if (!this._descriptionVO) {
      this._descriptionVO = this.model.localeEngine.newTranslatableVO(this, 'description');
    }
    return this._descriptionVO;
  }

  /* ################################################
                    Accesseurs composites
  ################################################ */

  /** Le format est-il persisté? */
  public get exist(): boolean {
    // l'objet existe en BDD (id)
    return this.source.id > 0;
  }

}
